import apiClient from '@/services/rest-api-sms/apiClient'
import stores from '@/state/store'

const baseEndpoint = '/hosted-zone'

export const get = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : ['id desc'],
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  const hasUpdatePermission = stores.getters['identity/hasAccess']('sms-hosted-zone:update')
  const hasDeletePermission = stores.getters['identity/hasAccess']('sms-hosted-zone:delete')
  
  response.data.data?.paginated_result?.forEach((val) => {
    val['can_edit'] = hasUpdatePermission
    val['can_delete'] = hasDeletePermission
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: {
      filters: [`id eq ${id}`]
    }
  })
  let result = response?.data.data?.paginated_result[0]
  result['can_edit'] = true
  result['can_delete'] = true
  return result
}

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    data: {
      hosted_zone_id: data.hosted_zone_id,
      hosted_zone_name: data.hosted_zone_name,
      value_route: data.value_route,
    },
  })
  return response
}

export const update = async (id, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data: {
      hosted_zone_id: data.hosted_zone_id,
      hosted_zone_name: data.hosted_zone_name,
      value_route: data.value_route,
    },
  })
  return response
}

export const deleteMany = async (data) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}`,
    data,
  })
  return response
}
